import { ActionReducerMap } from '@ngrx/store';
import { GlobalState } from '../interfaces/store/store.interface';
import { GlobalReducer } from './global/global.reducer';

export interface State {
    global: GlobalState;
}

export const reducers: ActionReducerMap<State> = {
    global: GlobalReducer,
};
